export default __webpack_public_path__ + "static/media/2106_00A.9f36f263.jpg";